import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";
 
 
export const GetGeneralProcedureDetail = (params: any) =>
  GET_ENC(`${BASE_URL}/api/GeneralProcedure/GetDetail?` + params, null);

export const GetGeneralProcedureList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/GeneralProcedure/GetList?` + params, null);

export const CreateGeneralProcedure = (data: any) =>
  POST_ENC(`${BASE_URL}/api/GeneralProcedure/Create`, data);

export const UpdateGeneralProcedure = (data: any) =>
  POST_ENC(`${BASE_URL}/api/GeneralProcedure/Update`, data);    

export const DeleteGeneralProcedure = (data: any) =>
  POST_ENC(`${BASE_URL}/api/GeneralProcedure/Delete`, data);